import {
  getAuth,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  signInWithPopup,
} from 'firebase/auth'
import { FirebaseUserCredentials } from '../types/Types.ts'

const provider = new GoogleAuthProvider()

export const SignInWithGoogle = async () => {
  const auth = getAuth()
  await signInWithPopup(auth, provider)
}

export const SingUpWithGoogle = async (): Promise<FirebaseUserCredentials> => {
  const auth = getAuth()
  const userCredential = await signInWithPopup(auth, provider)
  const idToken = await userCredential.user.getIdToken(true)

  const name = userCredential.user.displayName
  const email = userCredential.user.email

  if (!name || !email) {
    throw new Error('User name or email is missing')
  }

  return new Promise((resolve) => {
    resolve({
      name: userCredential.user.displayName ?? '',
      email: userCredential.user.email ?? '',
      firebaseUid: userCredential.user.uid,
      accessToken: idToken,
    })
  })
}

export const SendPasswordResetEmail = async (email: string) => {
  const auth = getAuth()
  await sendPasswordResetEmail(auth, email)
}
